import { useCallback, useEffect, useState } from "react";
import { PERMISSIONS } from "../const";

const usePermission = (topic, pageName) => {
  const [data, setData] = useState([]);
  const [isAll, setIsAll] = useState(false);

  const fetchData = useCallback(
    async (topic, pageName) => {
      const permissions = localStorage.getItem(PERMISSIONS);
      if (topic) {
        const _p = JSON.parse(permissions);
        const data = _p.filter((item) => item.permissionName === topic);
        const list = data[0]?.permissionList;

        if (pageName) {
          const role = list?.filter((item) => item.pageName === pageName);
          setData(role);
        } else {
          setData(data);
        }

        // check admin
        let isAll = [];
        for (let i = 0; i < list?.length; i++) {
          isAll.push(list[i].isAll);
        }

        // console.log("isAll array", isAll);
        isAll.includes(false) ? setIsAll(false) : setIsAll(true);
        // isAll.includes(false) ? console.log("false") : console.log("true");
      } else {
        setData(JSON.parse(permissions));
      }
    },
    [setData]
  );

  useEffect(() => {
    fetchData(topic, pageName);
  }, [fetchData, topic, pageName]);

  return [data, isAll];
};

export default usePermission;
